import { type UseQueryResult, useQuery } from 'react-query';
import { RsuAwardApprovalService } from '../../services/wealthlane-award-services';

const useGetRsuApprovalAwardNumber = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  id: string,
  isApprover: boolean | undefined
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const rsuApprovalAwardNumberOptions = useQuery(
    ['getRsuApprovalAwardNumberOptions', id],
    async () => {
      return isApprover ?? false
        ? await handleRequest(
            RsuAwardApprovalService.getApiAwardApiAppRSUAwardApprovalRSUAwardNumbers(id)
          )
        : [];
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.awardNumber ?? '',
            value: item.rsuAwardId ?? '',
          };
        });
      },
    }
  );

  return rsuApprovalAwardNumberOptions;
};

export default useGetRsuApprovalAwardNumber;
